import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { ResolvableModal} from '@softline/ui-core';
import { ArtikelMenge, Lagerplatz } from '@softapps/lager/core';

import { IconComponent } from '@softline/ui-core';
@Component({
  selector: 'soft-select-lagerplatz-modal',
  imports: [
    IconComponent
  ],
  templateUrl: './select-lagerplatz-modal.component.html',
  styleUrls: ['./select-lagerplatz-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush })
export class SelectLagerplatzModalComponent extends ResolvableModal<
  Lagerplatz | 'ALL_STORAGE_LOCATIONS'
> {
  readonly lagerplaetzeInhalt =
    input<{ inhalt: ArtikelMenge[]; lagerplatz: Lagerplatz }[]>();

  readonly data = computed(() => {
    return this.lagerplaetzeInhalt()?.map((lagerplatz) => ({
      menge: lagerplatz.inhalt.reduce((a, b) => a + b.menge, 0),
      einheit: lagerplatz.inhalt.length > 0 ? lagerplatz.inhalt[0].einheit : null,
      mengeLager: lagerplatz.inhalt.reduce((a, b) => a + b.menge_lg, 0),
      einheitLager: lagerplatz.inhalt.length > 0 ? lagerplatz.inhalt[0].einheit_lg : null,
      lagerplatz: lagerplatz.lagerplatz }));
  });
}
